import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import { useState } from 'react';

export default function Privacy() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      <Header mobileMenuOpen={mobileMenuOpen} setMobileMenuOpen={setMobileMenuOpen} />
      <main className="pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">個人情報の取り扱いについて</h1>
          
          <div className="bg-white rounded-2xl shadow-lg p-8 space-y-8">
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">個人情報保護方針</h2>
              <p className="text-gray-700 leading-relaxed">
                アシーブメント（以下「当社」といいます）は、お客様の個人情報の保護に最大限の注意を払い、以下の方針に基づいて個人情報を適切に取り扱います。
              </p>
            </section>

            <section>
              <h3 className="text-xl font-bold text-gray-900 mb-3">1. 個人情報の収集について</h3>
              <p className="text-gray-700 leading-relaxed mb-3">
                当社は、以下の目的のために必要な範囲で個人情報を収集いたします。
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                <li>お問い合わせへの対応</li>
                <li>サービスの提供および改善</li>
                <li>お客様へのご連絡</li>
                <li>各種ご案内の送付</li>
              </ul>
            </section>

            <section>
              <h3 className="text-xl font-bold text-gray-900 mb-3">2. 個人情報の利用目的</h3>
              <p className="text-gray-700 leading-relaxed mb-3">
                当社は、収集した個人情報を以下の目的で利用いたします。
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                <li>お客様からのお問い合わせに対する回答</li>
                <li>サービスに関する情報提供</li>
                <li>契約の履行および管理</li>
                <li>アフターサービスの提供</li>
                <li>新サービスや製品に関する情報のご案内</li>
              </ul>
            </section>

            <section>
              <h3 className="text-xl font-bold text-gray-900 mb-3">3. 個人情報の第三者提供</h3>
              <p className="text-gray-700 leading-relaxed">
                当社は、法令に基づく場合を除き、お客様の同意なく個人情報を第三者に提供することはありません。
              </p>
            </section>

            <section>
              <h3 className="text-xl font-bold text-gray-900 mb-3">4. 個人情報の管理</h3>
              <p className="text-gray-700 leading-relaxed">
                当社は、個人情報の漏洩、滅失、毀損等を防止するため、適切な安全管理措置を講じます。また、個人情報を取り扱う従業員に対して、適切な監督を行います。
              </p>
            </section>

            <section>
              <h3 className="text-xl font-bold text-gray-900 mb-3">5. 個人情報の開示・訂正・削除</h3>
              <p className="text-gray-700 leading-relaxed">
                お客様は、当社が保有する自己の個人情報について、開示、訂正、削除等を求めることができます。ご希望の場合は、下記のお問い合わせ窓口までご連絡ください。
              </p>
            </section>

            <section>
              <h3 className="text-xl font-bold text-gray-900 mb-3">6. Cookie（クッキー）について</h3>
              <p className="text-gray-700 leading-relaxed">
                当社のウェブサイトでは、サービスの利便性向上のためCookieを使用する場合があります。Cookieの使用を希望されない場合は、ブラウザの設定で無効にすることができます。
              </p>
            </section>

            <section>
              <h3 className="text-xl font-bold text-gray-900 mb-3">7. 個人情報保護方針の変更</h3>
              <p className="text-gray-700 leading-relaxed">
                当社は、法令の変更等に伴い、本方針を変更することがあります。変更後の個人情報保護方針は、当ウェブサイトに掲載した時点から効力を生じるものとします。
              </p>
            </section>

            <section className="border-t pt-8">
              <h3 className="text-xl font-bold text-gray-900 mb-3">お問い合わせ窓口</h3>
              <div className="bg-blue-50 rounded-lg p-6 space-y-3">
                <p className="text-gray-900 font-semibold">アシーブメント</p>
                <p className="text-gray-700">
                  <span className="font-semibold">住所：</span>〒594-0071 大阪府和泉市府中町6丁目14-42
                </p>
                <p className="text-gray-700">
                  <span className="font-semibold">電話：</span>
                  <a href="tel:080-4010-5475" className="text-blue-500 hover:text-blue-600">080-4010-5475</a>
                </p>
                <p className="text-gray-700">
                  <span className="font-semibold">メール：</span>
                  <a href="mailto:acm01tsubo@gmail.com" className="text-blue-500 hover:text-blue-600">acm01tsubo@gmail.com</a>
                </p>
                <p className="text-gray-700">
                  <span className="font-semibold">受付時間：</span>平日 9:00〜18:00
                </p>
              </div>
            </section>

            <div className="text-center pt-8">
              <p className="text-gray-600 text-sm">制定日：2024年1月1日</p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
